import { useHistory, useRouteMatch } from "react-router-dom";
import { Button, Stack } from "@mui/material";

import { useCustomerContext } from "../../../Context/CustomerContext";
import SelectedAccountAndCluster from "../ClusterActivation/Steps/components/SelectedAccountAndCluster";
import { ClusterAgentStatus } from "../Clusters/Table/types";
import { sortedValueToOption } from "../Clusters/Table/utils";
import { useTrackKubernetesLensEventOnce } from "../events";
import { useCluster } from "../hooks";
import { InstallAgent, PageLayout } from "./Components";

const ClusterAgentInstallation = () => {
  const { customer } = useCustomerContext();
  const history = useHistory();
  const match = useRouteMatch<{ clusterId: string }>();

  const [cluster, clusterLoading] = useCluster(match.params.clusterId);

  useTrackKubernetesLensEventOnce({
    name: "Cluster Agent Install Started",
    properties: {
      clusterId: cluster?.id ?? "",
      clusterType: cluster?.type ?? "",
      agentStatus: sortedValueToOption(ClusterAgentStatus.NEVER_TRANSMITTED).label,
    },
    condition: !!cluster,
  });

  const handleCancel = () => {
    history.push(`/customers/${customer.id}/integrate/assets/kubernetes`);
  };

  const handleDone = () => {
    handleCancel();
  };

  const footer = (
    <Stack spacing={2} direction="row">
      <Button onClick={handleCancel}>Cancel</Button>
      <Button variant="contained" onClick={handleDone}>
        Done
      </Button>
    </Stack>
  );

  const subtitle = !!cluster && (
    <SelectedAccountAndCluster projectId={cluster.projectId ?? ""} selectedClusters={[cluster]} />
  );

  return (
    <PageLayout footer={footer} loading={clusterLoading} title="Install Agent" subtitle={subtitle}>
      <InstallAgent cluster={cluster} />
    </PageLayout>
  );
};

export default ClusterAgentInstallation;
